import axios from "axios";

export default class apiCodeforces {
	static api = axios.create({
		baseURL: "https://codeforces.com/api/",
		timeout: 10000,
		responseType: "json"
	});

	static cancelUserInfo = null;
	static cancelUserProblems = null;

	static getUserInfo(userHandle) {
		console.clear();
		apiCodeforces.cancelUserInfo && apiCodeforces.cancelUserInfo();

		return apiCodeforces.api.get(`user.info?handles=${userHandle}`, {
			cancelToken: new axios.CancelToken(function (cancel) {
				apiCodeforces.cancelUserInfo = cancel;
			})
		})
		.then(response => response.data)
		.then(data => {
			if (data.status === "OK") {
				return data.result[0];
			}
			else {
				return {};
			}
		});
	}

	static async getUserProblems(userHandle) {
		let problems = [];
		apiCodeforces.cancelUserProblems && apiCodeforces.cancelUserProblems();

		for (let i = 1; i < 10000001; i += 1000) {
			const response = await apiCodeforces.api.get(`user.status?handle=${userHandle}&from=${i}&count=${i + 999}`, {
				cancelToken: new axios.CancelToken(function (cancel) {
					apiCodeforces.cancelUserProblems = cancel;
				})
			});

			const data = response.data;
			
			if (data.status === "OK" && data.result.length > 0) {
				problems = [...problems, ...data.result];
			}
			else
				break;
		}
		
		// problem contestId, index
			
		const submissions = new Map();

		problems = problems.filter(submission => submission.verdict === "OK");

		problems.forEach(submission => {
			submissions.set(`${submission.problem.contestId}-${submission.problem.index}`, submission);
		});

		problems = [];

		submissions.forEach(problem => {
			problems.push(problem);
		});

		return problems;
	}
};